import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_UNSERVICEABLE_AREA_REQUEST,
    GET_ALL_UNSERVICEABLE_AREA_REQUESTS,
    GET_UNSERVICEABLE_AREA_REQUEST_REQUEST,
    DELETE_UNSERVICEABLE_AREA_REQUEST,
    CLEAR_UNSERVICEABLE_AREA_REQUEST
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Unserviceable Area Requests
export const getUnserviceableAreaRequests = (page = 1, limit = 10) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_UNSERVICEABLE_AREA_REQUEST_REQUEST,
        payload: true
    });
    
    try {
        const res =  await axios.get(`${API_URL}/unserviceable-area-requests?page=${page}&limit=${limit}`);

        if(res.data.success){            
            dispatch({
                type : GET_ALL_UNSERVICEABLE_AREA_REQUESTS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Unserviceable Area Requests', 'danger'));
    }
}

// Get a single Unserviceable Area Request
export const getUnserviceableAreaRequest = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_UNSERVICEABLE_AREA_REQUEST_REQUEST,
        payload: true
    });
    try {
        const res =  await axios.get(`${API_URL}/unserviceable-area-requests/${id}`);
        if(res.data.success){  
            dispatch({
                type : GET_UNSERVICEABLE_AREA_REQUEST,
                payload: res.data.data
            });
            dispatch( setAlert('Successfully fetched Unserviceable Area Request details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Unserviceable Area Request details', 'danger'));
    }
};

// Delete Unserviceable Area Request
export const deleteUnserviceableAreaRequest = (requestId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/unserviceable-area-requests/${requestId}`, config);
        
        if (res.data.success) {
            dispatch({
                type: DELETE_UNSERVICEABLE_AREA_REQUEST,
                payload: requestId
            });
            dispatch(setAlert('Unserviceable Area Request deleted successfully', 'success'));
            // Refresh the requests list
            dispatch(getUnserviceableAreaRequests());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete unserviceable area request', 'danger'));
    }
};

// Clear Unserviceable Area Request
export const clearUnserviceableAreaRequest = () => dispatch => {
    dispatch({
        type: CLEAR_UNSERVICEABLE_AREA_REQUEST,
        payload: null
    });
};
